<template>
	<div class="head_m" id="head_m">
    <van-nav-bar class="navbar" :class="navshow?'black':''"
        title="标题"
        right-text="按钮"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
    >
      <template #left>
        <router-link v-show="routerPath=='/m/Index'" to="/m/Index"><van-icon name="wap-home" size="28" :color="navshow?'#ffffff':'#231815'" /></router-link>
        <i v-show="routerPath!='/m/Index'" class="iconfont icon-left" :class="navshow?'white':''" @click="$router.go(-1);navshow=false;"></i>
      </template>
      <template #title>
        <img v-show="routerPath!='/m/Product' && routerPath!='/m/ProductInfo'" :src="navshow?require('../assets/img/logo.png'):require('../assets/img/logo_b.png')" alt="" class="logo" @click="Linkto('/m/Index')">
        <van-dropdown-menu v-show="routerPath=='/m/Product' || routerPath=='/m/ProductInfo'" class="menu" :class="navshow?'active':''" active-color="#FDA82B">
          <van-dropdown-item v-model="value1" :options="option1"  @change="changeMenu"/>
        </van-dropdown-menu>
      </template>
      <template #right>
        <van-icon :name="navshow?'cross':'wap-nav'" size="28" :color="navshow?'#ffffff':'#231815'" @click="navshow=!navshow"/>
      </template>
    </van-nav-bar>
    <van-popup class="mainnav" v-model="navshow" position="top">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1">
          <template #title>
            <div><i class="iconfont icon-layer"></i>Product</div>
          </template>
          <van-cell v-for="(item,index) in catList" :key="index" class="proList" :title="item.name" @click="proLinkto(index)"/>
        </van-collapse-item>
      </van-collapse>
      <van-cell class="navList" :class="far_nav==index+2?'on':''" :title="item.title" @click="Linkto(item.path)" v-for="(item,index) in nav.slice(2)" :key="index">
        <template #icon>
          <i class="iconfont" :class="item.icon"></i>
        </template>
      </van-cell>
    </van-popup>
	</div>
</template>

<script>
import * as $request from "../api";

export default {
  name: 'Header_m',
  props:{
    far_nav:Number,
  },
  data() {
    return {
      nav:[
        {title: 'Home', path: '/m/Index',icon:''},//0
        {title: 'Product', path: '/m/Product',icon:'',},//1
        {title: 'Application', path: '/m/Application',icon:'icon-yyzx-nor',},//2
        {title: 'Company', path: '/m/Company',icon:'icon-gongsi',},//3
        {title: 'Service', path: '/m/Service',icon:'icon-hezuo',},//4
        {title: 'FAQ', path: '/m/Faq',icon:'icon-chat',},//5
        {title: 'News', path: '/m/News',icon:'icon-newstextarticle',},//6
        {title: 'Contact', path: '/m/Contact',icon:'icon-call',},//7
      ],
      navshow:false,
      activeNames: ['0'],
      catList:[],
      routerPath:'',
      value1: 0,
      option1: [
        { text: ' Micro Perforated Acoustic Panel ', value: 0 },
      ],
    }
  },
  watch:{
    $route(newval){
      this.routerPath=newval.path
      if(newval.query.cin){
        this.value1=Number(newval.query.cin)
        // console.log(this.value1)
      }
      console.log(this.routerPath)
    },
    far_nav(newval){
      console.log(`nav:${newval}`)
    }
  },
  methods:{
    init(){
      ! function (e, t) {
        var n = t.documentElement,
            d = e.devicePixelRatio || 1;

        function i() {
          var e = n.clientWidth / 3.75;
          n.style.fontSize = e + "px"
        } if (function e() { t.body ? t.body.style.fontSize = "16px" : t.addEventListener("DOMContentLoaded", e) }(), i(), e.addEventListener("resize", i), e.addEventListener("pageshow", function (e) { e.persisted && i() }), d >= 2) {
          var o = t.createElement("body"),
              a = t.createElement("div");
          a.style.border = ".5px solid transparent", o.appendChild(a), n.appendChild(o), 1 === a.offsetHeight && n.classList.add("hairlines"), n.removeChild(o)
        }
      }(window, document)
    },
    changeMenu(e){
      this.$router.push(`/m/Product?cin=${e}`)
      location.reload()
      // this.navshow=false
    },
    Linkto(route){
      this.$router.push(route)
      this.navshow=false
    },
    proLinkto(index){
      this.value1=index
      this.$router.push(`/m/Product?cin=${index}`)
      this.navshow=false
    },
    onClickLeft() {
      // console.log('返回');
    },
    onClickRight() {
      // console.log('按钮');
    },
  },
  created() {
    this.init()
    this.routerPath=this.$route.path
    $request.getCats().then(res=>{
      res.forEach(val=>{
        if(val.name=='en'){
          this.catList=val.sonList
          this.option1=val.sonList
          this.option1.forEach((val,index)=>{
            val.text=val.name
            val.value=index
            this.value1=Number(this.$route.query.cin)
          })
          // console.log(this.option1)
        }
      })
    })
  },
}
</script>
<style>
/*@import "../assets/css/autosize.css";*/
</style>
<style lang="less" scoped>
#head_m{position: sticky;top: 0;z-index: 10000;box-shadow: 0 0 5px -1px rgba(0,0,0,.3);
  .navbar{z-index: 10000;
    /deep/ .van-nav-bar__content{height: .55rem;padding: .1rem 0;
      .logo{width: 1.2rem;}
      .van-nav-bar__left{
        .icon-left{font-size: .30rem;
          &.white{color: white;}
        }
      }
    }
    .menu{
      /deep/ .van-dropdown-menu__bar{height: .35rem;background: transparent;
        .van-dropdown-menu__title{padding: 0 .16rem;
          .van-ellipsis{font:.14rem Poppins-Medium;}
          &:after{width: 0px;height: 0px;color: white;text-align: center;border-top: .05rem solid transparent;border-left: .1rem solid @main-c4;border-bottom: .05rem solid transparent;transform: rotate(0);right: 0px;
            margin: -6px 0 0;
          }
          &.van-dropdown-menu__title--down::after{margin: -6px 0 0;border-left-color: @main-c1;}
        }
      }
      /deep/ .van-dropdown-item__content{
        .van-cell__title{font: .12rem Poppins-Medium;}
      }
      &.active{
        /deep/ .van-dropdown-menu__bar{
          .van-dropdown-menu__title{color:white;
            &:after{border-left-color: white;}
          }
        }
        /deep/ .van-dropdown-item__content{background: @main-c4;
          .van-cell{background: transparent;
            .van-cell__title{color: white;font: .12rem Poppins-Medium;}
            &.van-dropdown-item__option--active{
              .van-cell__title{color: @main-c1;}
            }
            &:after{border: none;}
          }
        }
      }
    }
    &:after{border:none;}
    &.black{background: @main-c4;}
  }
  .mainnav{padding: .55rem 0 0;
    /deep/ *:after{border: none;}
    /deep/ .van-cell,/deep/ .van-collapse-item__content{background: @main-c4;color: white;
      .van-cell__right-icon{color: white;}
    }
    /deep/ .van-cell{display: flex;align-items: baseline;
      .van-cell__title{font:.14rem Poppins-Medium;
        //&>div{display: flex;align-items: center;}
        .iconfont{font-size:.18rem;top: .02rem;position: relative;margin: 0 .1rem 0 0;}
      }
      &.van-collapse-item__title--expanded{background: @main-c1;color: @main-c4;
        .van-cell__right-icon{color: @main-c4;}
      }
    }
    /deep/ .van-collapse-item__content{padding: 0;
      .proList{padding-left:.44rem;background: transparent;
        van-cell__title{font-size: .18rem;}
      }
      &:active,&.on{background: @main-c1;
        .proList{color: @main-c4;}
      }
    }
    .navList{
      i{font-size: 0.14rem;top: 0px;position: relative;margin: 0 0.125rem 0 0.025rem;}
      &:active,&.on{background: @main-c1;color: @main-c4;}
    }
  }
}
</style>
